import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {URLSearchParams} from './utils/url'
import {globalData} from './common/config'
import {currentProductCode} from './productConfig'

const urlParams =  (URLSearchParams(window.location.href)) as any
globalData['productCode'] = urlParams['productCode']||currentProductCode;
globalData['gUrlData'] = urlParams
ReactDOM.render(<App />, document.getElementById('app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
